import dayjs from 'dayjs';
import { container, I18N_TOKEN } from '@/container';
import type { DateFormatFunctions } from './type';

export const formatCollection: DateFormatFunctions = {
  today: () => container.resolve(I18N_TOKEN).t('common.today'),
  yesterday: () => container.resolve(I18N_TOKEN).t('common.yesterday'),
  sameYear: (date) => dayjs(date).format('MM/DD'),
  otherDay: (date) => dayjs(date).format('YYYY/M/D'),
};

export const formatCollectionPreview: DateFormatFunctions = {
  today: (date) => `${container.resolve(I18N_TOKEN).t('common.today')} ${dayjs(date).locale('en').format('h:mmA')}`,
  yesterday: (date) =>
    `${container.resolve(I18N_TOKEN).t('common.yesterday')} ${dayjs(date).locale('en').format('h:mmA')}`,
  sameYear: (date) => dayjs(date).locale('en').format('M/D/YYYY h:mmA'),
  otherDay: (date) => dayjs(date).locale('en').format('M/D/YYYY h:mmA'),
};

export const formatGroupedMessage: DateFormatFunctions = {
  today: () => container.resolve(I18N_TOKEN).t('common.today'),
  yesterday: () => container.resolve(I18N_TOKEN).t('common.yesterday'),
  sameYear: (date) => dayjs(date).format('dddd, MM/DD'),
  otherDay: (date) => dayjs(date).format('dddd, YYYY/MM/DD'),
};
